import { useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import styles from './styles.module.scss'

import logo from '@/assets/images/wisprLogo.svg?url'
import { selectCurrentEnterprise } from '@/store/features/user/userSlice'

const OrgSwitcher = () => {
  const enterprise = useSelector(selectCurrentEnterprise)
  const [isSelectorOpen, setSelectorOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  return (
    <div ref={menuRef} className={styles.org} onClick={() => setSelectorOpen(!isSelectorOpen)}>
      <img className={styles.logo} src={enterprise!.logo || logo} alt="Logo" />
      <div className={styles.name}>{enterprise!.name}</div>
    </div>
  )
}

export default OrgSwitcher
